import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ConditionsUtilisationPage() {
  const handleDownload = () => {
    const content = document.getElementById('legal-content');
    if (!content) return;

    // Créer le contenu HTML complet
    const htmlContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Conditions d'Utilisation - Clinique Sainte Famille</title>
          <style>
            @page { 
              margin: 2cm; 
              size: A4;
            }
            body { 
              font-family: Arial, sans-serif; 
              padding: 0; 
              margin: 0;
              line-height: 1.6; 
              color: #333; 
              font-size: 12px;
            }
            h1 { 
              color: #1e40af; 
              font-size: 24px; 
              margin-bottom: 20px; 
              page-break-after: avoid;
            }
            h2 { 
              color: #1e40af; 
              font-size: 18px; 
              margin-top: 25px; 
              margin-bottom: 12px; 
              page-break-after: avoid;
            }
            h3 { 
              color: #1e40af; 
              font-size: 14px; 
              margin-top: 15px; 
              margin-bottom: 8px; 
              page-break-after: avoid;
            }
            p, li { 
              margin-bottom: 8px; 
              page-break-inside: avoid;
            }
            ul { 
              margin-left: 20px; 
            }
            .info-box { 
              background: #f8f9fa; 
              padding: 12px; 
              border-left: 4px solid #1e40af;
              margin: 12px 0; 
              page-break-inside: avoid;
            }
            .grid { 
              display: block; 
            }
            .grid > div { 
              margin-bottom: 10px; 
              page-break-inside: avoid;
            }
            section { 
              page-break-inside: avoid; 
              margin-bottom: 20px;
            }
            @media print {
              body { print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `;

    // Créer un blob avec le contenu HTML
    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    
    // Créer un lien de téléchargement
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Conditions-Utilisation-Clinique-Sainte-Famille.html';
    link.style.display = 'none';
    
    // Ajouter au DOM, cliquer et nettoyer
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Libérer l'URL après un court délai
    setTimeout(() => URL.revokeObjectURL(url), 100);
    
    // Afficher un message de confirmation
    const notification = document.createElement('div');
    notification.className = 'fixed bottom-4 right-4 bg-clinic-green text-white px-6 py-3 rounded-full shadow-lg z-50 flex items-center gap-2';
    notification.innerHTML = '<i class="ri-check-line"></i> Fichier téléchargé avec succès';
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.remove();
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      <div className="flex-1 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={handleDownload}
              className="flex items-center gap-2 px-6 py-3 bg-clinic-blue text-white rounded-full hover:bg-clinic-blue-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line text-lg"></i>
              Télécharger en PDF
            </button>
          </div>
          <div className="bg-white rounded-3xl shadow-xl border-2 border-clinic-blue/10 p-8 md:p-12" id="legal-content">
            <div className="mb-8">
              <div className="w-16 h-16 bg-clinic-blue/10 rounded-2xl flex items-center justify-center mb-4">
                <i className="ri-file-list-3-line text-3xl text-clinic-blue"></i>
              </div>
              <h1 className="text-4xl font-bold text-clinic-blue-dark mb-2">Conditions Générales d'Utilisation</h1>
              <p className="text-gray-600">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">1. Objet</h2>
                <p className="text-gray-700">
                  Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités et conditions 
                  d'utilisation de la plateforme en ligne de la Clinique Sainte Famille, ainsi que les droits et obligations 
                  des utilisateurs dans ce cadre.
                </p>
                <div className="bg-clinic-blue/5 border-l-4 border-clinic-blue p-4 rounded-lg mt-4">
                  <p className="text-sm text-clinic-blue-dark">
                    <i className="ri-information-line mr-2"></i>
                    L'utilisation de la plateforme implique l'acceptation pleine et entière des présentes CGU.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">2. Accès à la Plateforme</h2>
                
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">2.1 Conditions d'Accès</h3>
                    <p className="text-gray-700 mb-3">
                      La plateforme est accessible gratuitement à toute personne disposant d'un accès internet. 
                      Tous les coûts afférents à l'accès à la plateforme sont à la charge de l'utilisateur.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Connexion internet requise</li>
                      <li>Navigateur web récent recommandé</li>
                      <li>Création d'un compte utilisateur obligatoire pour certains services</li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">2.2 Création de Compte</h3>
                    <p className="text-gray-700 mb-3">
                      Pour accéder aux services de prise de rendez-vous et de gestion de dossier médical, 
                      vous devez créer un compte en fournissant des informations exactes et à jour.
                    </p>
                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                      <p className="text-sm text-yellow-800">
                        <i className="ri-alert-line mr-2"></i>
                        Vous êtes responsable de la confidentialité de vos identifiants de connexion. 
                        Toute utilisation de votre compte est présumée être effectuée par vous.
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">2.3 Disponibilité</h3>
                    <p className="text-gray-700">
                      La Clinique Sainte Famille s'efforce d'assurer une disponibilité de la plateforme 24h/24 et 7j/7. 
                      Toutefois, des interruptions peuvent survenir pour maintenance ou en cas de force majeure.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">3. Services Proposés</h2>
                
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-calendar-check-line mr-2 text-clinic-blue"></i>
                      Prise de Rendez-vous
                    </h3>
                    <p className="text-sm text-gray-700">Réservation en ligne de consultations médicales</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-folder-user-line mr-2 text-clinic-blue"></i>
                      Dossier Médical
                    </h3>
                    <p className="text-sm text-gray-700">Accès sécurisé à votre historique médical</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-file-text-line mr-2 text-clinic-blue"></i>
                      Prescriptions
                    </h3>
                    <p className="text-sm text-gray-700">Consultation de vos ordonnances et prescriptions</p>
                  </div>

                  <div className="bg-clinic-blue/5 p-4 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                      <i className="ri-notification-line mr-2 text-clinic-blue"></i>
                      Notifications
                    </h3>
                    <p className="text-sm text-gray-700">Rappels de rendez-vous et alertes médicales</p>
                  </div>
                </div>

                <div className="bg-clinic-green/10 border-2 border-clinic-green/30 p-6 rounded-2xl mt-6">
                  <p className="text-gray-700">
                    <strong>Important :</strong> Les services en ligne ne remplacent pas une consultation médicale en personne. 
                    En cas d'urgence médicale, contactez immédiatement les services d'urgence ou présentez-vous à la clinique.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">4. Obligations de l'Utilisateur</h2>
                
                <div className="space-y-4">
                  <div className="border-l-4 border-clinic-green pl-4">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">4.1 Informations Exactes</h3>
                    <p className="text-gray-700">
                      Vous vous engagez à fournir des informations exactes, complètes et à jour, notamment concernant 
                      votre état de santé, vos antécédents médicaux et vos coordonnées.
                    </p>
                  </div>

                  <div className="border-l-4 border-clinic-green pl-4">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">4.2 Utilisation Conforme</h3>
                    <p className="text-gray-700 mb-2">Vous vous engagez à utiliser la plateforme de manière conforme à sa destination et à ne pas :</p>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Usurper l'identité d'une autre personne</li>
                      <li>Diffuser des informations fausses ou trompeuses</li>
                      <li>Tenter d'accéder aux données d'autres utilisateurs</li>
                      <li>Perturber le fonctionnement de la plateforme</li>
                      <li>Utiliser la plateforme à des fins illégales</li>
                    </ul>
                  </div>

                  <div className="border-l-4 border-clinic-green pl-4">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">4.3 Sécurité du Compte</h3>
                    <p className="text-gray-700">
                      Vous êtes responsable de la confidentialité de vos identifiants. En cas de perte ou de vol, 
                      vous devez immédiatement en informer la Clinique Sainte Famille.
                    </p>
                  </div>

                  <div className="border-l-4 border-clinic-green pl-4">
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">4.4 Respect des Rendez-vous</h3>
                    <p className="text-gray-700">
                      En cas d'empêchement, vous vous engagez à annuler votre rendez-vous au moins 24 heures à l'avance 
                      afin de permettre à d'autres patients d'en bénéficier.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">5. Protection des Données</h2>
                <p className="text-gray-700 mb-4">
                  Conformément à la <strong>loi n°2017-20 du Bénin sur la protection des données personnelles</strong>, 
                  vos données personnelles et médicales sont traitées de manière sécurisée et confidentielle.
                </p>
                <div className="bg-clinic-blue/5 border-2 border-clinic-blue/20 p-6 rounded-2xl">
                  <p className="text-gray-700 mb-3">
                    <strong>Les données médicales collectées sont traitées conformément à la loi n°2017-20 du Bénin 
                    sur la protection des données personnelles et déclarées auprès de l'APDP.</strong>
                  </p>
                  <p className="text-gray-700">
                    Pour plus d'informations, consultez notre <a href="/politique-confidentialite" className="text-clinic-blue hover:underline font-semibold">Politique de Confidentialité</a>.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">6. Propriété Intellectuelle</h2>
                <p className="text-gray-700 mb-4">
                  Tous les éléments de la plateforme (textes, images, logos, design, structure) sont protégés par 
                  le droit de la propriété intellectuelle et appartiennent à la Clinique Sainte Famille.
                </p>
                <p className="text-gray-700">
                  Toute reproduction, représentation, modification ou exploitation non autorisée est interdite 
                  et constitue une contrefaçon sanctionnée par la loi.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">7. Responsabilité</h2>
                
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">7.1 Responsabilité de la Clinique</h3>
                    <p className="text-gray-700">
                      La Clinique Sainte Famille s'engage à fournir un service de qualité mais ne peut garantir 
                      l'absence totale d'erreurs ou d'interruptions. Sa responsabilité ne peut être engagée qu'en 
                      cas de faute prouvée.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">7.2 Responsabilité de l'Utilisateur</h3>
                    <p className="text-gray-700">
                      L'utilisateur est seul responsable de l'utilisation qu'il fait de la plateforme et des 
                      informations qu'il y communique. Il s'engage à indemniser la Clinique en cas de préjudice 
                      résultant d'une utilisation non conforme.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-2">7.3 Limitation de Responsabilité</h3>
                    <p className="text-gray-700">
                      La plateforme est un outil d'aide à la gestion des rendez-vous et du suivi médical. 
                      Elle ne remplace en aucun cas une consultation médicale en personne ni un diagnostic médical.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">8. Modification des CGU</h2>
                <p className="text-gray-700 mb-4">
                  La Clinique Sainte Famille se réserve le droit de modifier les présentes CGU à tout moment. 
                  Les utilisateurs seront informés de toute modification substantielle.
                </p>
                <p className="text-gray-700">
                  La poursuite de l'utilisation de la plateforme après modification des CGU vaut acceptation 
                  des nouvelles conditions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">9. Résiliation</h2>
                <div className="space-y-3">
                  <p className="text-gray-700">
                    <strong>Par l'utilisateur :</strong> Vous pouvez à tout moment demander la suppression de votre compte 
                    en contactant la Clinique Sainte Famille.
                  </p>
                  <p className="text-gray-700">
                    <strong>Par la Clinique :</strong> En cas de violation des présentes CGU, la Clinique se réserve le droit 
                    de suspendre ou supprimer votre compte sans préavis.
                  </p>
                  <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                    <p className="text-sm text-yellow-800">
                      <i className="ri-alert-line mr-2"></i>
                      La suppression du compte n'entraîne pas la suppression de votre dossier médical, 
                      qui est conservé conformément aux obligations légales.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">10. Droit Applicable et Litiges</h2>
                <div className="bg-gray-50 p-6 rounded-2xl">
                  <p className="text-gray-700 mb-3">
                    <strong>Droit applicable :</strong> Les présentes CGU sont régies par le droit béninois.
                  </p>
                  <p className="text-gray-700 mb-3">
                    <strong>Règlement amiable :</strong> En cas de litige, nous vous encourageons à nous contacter 
                    pour trouver une solution amiable.
                  </p>
                  <p className="text-gray-700">
                    <strong>Juridiction compétente :</strong> À défaut de résolution amiable, les tribunaux de Cotonou (Bénin) 
                    seront seuls compétents.
                  </p>
                </div>
              </section>

              <section className="bg-clinic-blue/5 p-6 rounded-2xl border-2 border-clinic-blue/20">
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">Contact</h2>
                <p className="text-gray-700 mb-4">
                  Pour toute question concernant ces conditions d'utilisation :
                </p>
                <div className="space-y-2 text-gray-700">
                  <p><i className="ri-mail-line mr-2 text-clinic-blue"></i><strong>Email :</strong> clinicfam@yahoo.com</p>
                  <p><i className="ri-phone-line mr-2 text-clinic-blue"></i><strong>Téléphone :</strong> +229 01 95 40 58 91</p>
                  <p><i className="ri-map-pin-line mr-2 text-clinic-blue"></i><strong>Adresse :</strong> 99QX+7W, Cotonou Bénin - 04 BP 127 lot 1862 Fifadji</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
